/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAppUpdateMutationVariables = Types.Exact<{
  input: Types.IAppUpdateInput;
}>;

export type IAppUpdateMutation = {
  __typename?: 'Mutation';
  appUpdate?: {
    __typename?: 'AppUpdatePayload';
    errors?: Array<string> | null;
    success: boolean;
    app?: {
      __typename?: 'App';
      description?: string | null;
      industry?: string | null;
      jurisdiction?: string | null;
      softwareType?: string | null;
      kind: Types.AppKindEnum;
      includedApps?: Array<string> | null;
      updatedAt: any;
      id: string;
      name?: string | null;
      criticality?: Types.AppCriticalityEnum | null;
      unclaimed: boolean;
      owned: boolean;
      ownerName: string;
      logoUrl?: string | null;
      taskCounts: Array<{ __typename?: 'TaskCount'; criticality: Types.TaskCriticalityEnum; count: number }>;
      policy: { __typename?: 'AppPolicy'; update: boolean; remove: boolean };
    } | null;
  } | null;
};

export const AppUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'appUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppUpdateInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'app' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppBaseFields' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'softwareType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includedApps' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppBaseFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'App' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unclaimed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'owned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remove' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAppUpdateMutation, IAppUpdateMutationVariables>;
